import api from '@/api'

const { $pricing, $core } = api;

export const { $prices, $products, $types, $zones } = $pricing;
export const { $cities, $users } = $core;
